<div class="dashboard">
  <iu-favorite-group-ui (favoriteClicked)="openTab($event)"></iu-favorite-group-ui>
  <iu-widget-group-ui (widgetClicked)="openTab($event)"></iu-widget-group-ui>
</div>
